import { motion } from "framer-motion";
import { Sparkles, Target, Zap, HandshakeIcon, Lightbulb } from "lucide-react";
import { VALUES } from "@/lib/constants";
import Seo from "@/components/Seo";
import CTABand from "@/components/sections/CTABand";

const OFFICE_IMG = "https://images.pexels.com/photos/6476257/pexels-photo-6476257.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function About() {
  return (
    <div data-testid="about-page">
      <Seo
        title="À propos"
        description="Passerelle Numérique Inc. accompagne les PME québécoises dans leur transformation numérique grâce au web, à l'IA et aux solutions sur mesure."
        path="/a-propos"
      />
      <section className="bg-white pt-16 pb-16">
        <div className="mx-auto max-w-7xl px-6 md:px-10 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-3">À propos</div>
            <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-[#0B1F3A] tracking-tighter text-balance">
              PASSERELLE NUMÉRIQUE INC.
            </h1>
            <p className="mt-5 text-lg text-[#4B5563]">
              Nous sommes une agence de transformation numérique basée à <strong className="text-[#0B1F3A]">Montréal</strong>, dédiée à accompagner les PME québécoises dans leur croissance.
            </p>
            <div className="mt-6 p-6 bg-[#F5F7FA] border-l-4 border-[#00B8D9] rounded-r-xl">
              <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-2">Notre mission</div>
              <p className="text-[#0B1F3A] font-medium">
                Accompagner les PME dans leur transformation numérique grâce au web, à l'intelligence artificielle et aux solutions sur mesure.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-xl">
            <img src={OFFICE_IMG} alt="Équipe Passerelle Numérique" className="w-full aspect-[4/3] object-cover" />
          </div>
        </div>
      </section>

      <section className="bg-[#F5F7FA] py-20">
        <div className="mx-auto max-w-7xl px-6 md:px-10">
          <div className="max-w-2xl mb-12">
            <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-3">Nos valeurs</div>
            <h2 className="font-heading font-black text-3xl sm:text-4xl text-[#0B1F3A] tracking-tight">Ce qui nous différencie</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {VALUES.map((v, i) => {
              const icons = [Lightbulb, Sparkles, Target, HandshakeIcon];
              const Icon = icons[i] || Zap;
              return (
                <motion.div key={v.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.08 }}
                  data-testid={`value-card-${i}`}
                  className="bg-white rounded-2xl p-6 border border-gray-200 hover:border-[#00B8D9] hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                  <div className="h-12 w-12 rounded-lg bg-[#00B8D9]/10 flex items-center justify-center mb-4">
                    <Icon className="h-6 w-6 text-[#00B8D9]" />
                  </div>
                  <h3 className="font-heading font-bold text-xl text-[#0B1F3A] mb-2">{v.title}</h3>
                  <p className="text-sm text-[#4B5563]">{v.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
